import axios from "./axios";

export const createLesson = (id, body) =>
  axios
    .post(`/admin/courses/${id}/lessons`, { ...body })
    .then(({ data }) => data);

export const updateLesson = (courseId, lessonId, body) =>
  axios
    .put(`/admin/courses/${courseId}/lessons/${lessonId}`, { ...body })
    .then(({ data }) => data);

export const deleteLesson = (courseId, lessonId) =>
  axios
    .delete(`/admin/courses/${courseId}/lessons/${lessonId}`)
    .then(({ data }) => data);

export const submitLesson = (courseId, lessonId, formData) =>
  axios
    .post(`/courses/${courseId}/lessons/${lessonId}/submit`, formData)
    .then(({ data }) => data);

export const submitLessonFacilitator = (courseId, lessonId, formData) => {
  return axios
    .post(`/courses/${courseId}/lessons/${lessonId}/submit_facilitator`, formData)
    .then(({ data }) => data);
};

export const updateSubmitLesson = (courseId, lessonId, formData) =>
  axios
    .put(`/courses/${courseId}/lessons/${lessonId}/update_submit`, formData)
    .then(({ data }) => data);

export const updateCourseLessonsProgress = (courseId, formData) =>
  axios
    .post(`/courses/${courseId}/lessons/progress`, formData)
    .then(({ data }) => data);

export const getCourseLessonsProgress = (courseId) =>
  axios
    .get(`/courses/${courseId}/lessons/progress`)
    .then(({ data }) => data);


export const incrementQuizQuestionAttempts = (quizQuestionId, selectedOptionId) =>
  axios
    .post(`/quiz_questions/${quizQuestionId}/submit`, { selected_option_id: selectedOptionId })
    .then(({ data }) => data);

